<div class="gtin-redirect-container">
  <div *ngIf="loading" class="loading-spinner">
    <div class="spinner"></div>
    <p>Verifying GTIN Link...</p>
  </div>

  <div *ngIf="!loading && errorMessage" class="error-message">
    <p>{{ errorMessage }}</p>
  </div>
</div>
